import axios from "axios";

export default axios.create({
  baseURL: "http://qa.klinicq.com",
  headers: {
    "Content-type": "application/json"
  }
});